import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const credits = resourceReducer('credit', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default credits;

export const getUserCredit = (state, page = 1) =>
  getResources(state, `userCredit${page}`);
export const getCredit = (state, creditId) =>
  getResources(state, [creditId])[0];
export const getCreditNotFound = (state, creditId) =>
  state.meta[creditId] && state.meta[creditId].readStatusCode === 404;
